export default __webpack_public_path__ + "static/media/computer-2569652.45f6655a.jpg";